import ScreenUtils from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const ChannelFilterSearchContainer = styled.div<{ focused?: boolean }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: ${60 * ScreenUtils.widthRatio}px;
  margin-right: ${18 * ScreenUtils.widthRatio}px;
  opacity: ${(props) => (props?.focused ? '1' : '0.5')};
  &:hover {
    opacity: 1;
  }
`;

export default withAnimation(ChannelFilterSearchContainer);
